if (!customElements.get('ozera-faq-accordion')) {
  customElements.define('ozera-faq-accordion', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.answer = this.querySelector('.ozera-faq__answer-wrapper');
      if (!this.details || !this.summary || !this.answer) return;

      this.syncState = () => {
        const open = this.details.open;
        this.summary.setAttribute('aria-expanded', String(open));
        this.answer.inert = !open;
        this.answer.setAttribute('aria-hidden', String(!open));
      };
      this.details.addEventListener('toggle', this.syncState);
      this.syncState();
    }

    disconnectedCallback() {
      if (this.details && this.syncState) {
        this.details.removeEventListener('toggle', this.syncState);
      }
    }
  });
}
